import { useLocation } from 'wouter'
import { ArrowLeft02Icon } from '@hugeicons/core-solid-rounded'

import { CreateOrganizationForm } from '@/features/organization'
import { useAuth } from '@/features/auth'
import { HugeiconsIcon } from '@hugeicons/react'
import { CurrentUserButton } from '@/features/user'

function CreateOrganization() {
  const { session } = useAuth()
  const [, navigate] = useLocation()

  return (
    <div className="w-screen h-screen mesh-bg-primary p-4 overflow-y-auto">
      <div className="flex flex-col justify-center min-h-full">
        <div className="flex flex-col bg-white rounded max-w-[600px] w-full p-6 gap-2.5 mx-auto">
          <div className="flex flex-row justify-start gap-2.5">
            {!!session?.currentOrgId && (
              <button tabIndex={0} onClick={() => navigate('/goodies')}>
                <HugeiconsIcon
                  icon={ArrowLeft02Icon}
                  className="size-6 text-text"
                />
              </button>
            )}
            <CurrentUserButton type="image_only" />
          </div>
          <CreateOrganizationForm />
        </div>
      </div>
    </div>
  )
}

export default CreateOrganization
